import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { CmsProvider } from './context/CmsContext'
import { Layout } from './components/Layout'
import {
  AboutPage, BlogDetailPage, BlogsPage, CareersPage, ContactPage, HomePage,
  IndustriesPage, LegalPage, NotFoundPage, PackagesPage, ServiceDetailPage,
  ServicesPage, WorkPage
} from './pages'

export default function App() {
  return <BrowserRouter>
    <CmsProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about-us" element={<AboutPage />} />
          <Route path="our-services" element={<ServicesPage />} />
          <Route path="services/:slug" element={<ServiceDetailPage />} />
          <Route path="industries" element={<IndustriesPage />} />
          <Route path="packages" element={<PackagesPage />} />
          <Route path="our-work" element={<WorkPage />} />
          <Route path="blogs" element={<BlogsPage />} />
          <Route path="blogs/:slug" element={<BlogDetailPage />} />
          <Route path="careers" element={<CareersPage />} />
          <Route path="contact-us" element={<ContactPage />} />
          <Route path=":slug" element={<LegalPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </CmsProvider>
  </BrowserRouter>
}
